import classNames from "classnames";
import React from "react";

import { ITestable, testAttr } from "@/browser";

import { IBlurable, IChangeable, ICheckable, IInputBasicProps, IStyleBasicProps } from "../types";

export interface ICheckboxProps
  extends IBlurable,
    IChangeable,
    ICheckable,
    IInputBasicProps,
    IStyleBasicProps,
    ITestable {}

interface State {
  checked: boolean;
}

export class Checkbox extends React.PureComponent<ICheckboxProps, State> {
  static defaultProps: Partial<ICheckboxProps> = {
    autoComplete: "off",
  };

  readonly state = { checked: !!this.props.checked };

  componentDidUpdate(_prevProps: ICheckboxProps, prevState: State) {
    if (prevState.checked !== !!this.props.checked) {
      this.setState({ checked: !!this.props.checked });
    }
  }

  handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { onChange } = this.props;

    if (onChange) {
      onChange(event.currentTarget.checked, event.currentTarget.name);
    }
  };

  handleBlur = () => {
    const { onBlur } = this.props;

    if (onBlur) {
      onBlur();
    }
  };

  render() {
    const {
      checked,
      value,
      children,
      indeterminate,
      onChange,
      onBlur,
      invalid,
      touched,
      size,
      testName,
      testValue,
      ...rest
    } = this.props;

    const refInput = (input: any) => {
      if (input) {
        input.indeterminate = indeterminate;
      }
    };

    const checkboxShapeClasses = classNames("el-form-checkbox__shape", {
      "el-form-checkbox__shape--not-valid": invalid,
    });

    const label = children && <span className="el-form-checkbox__label">{children}</span>;

    return (
      <label className="el-form-checkbox" {...testAttr(this.props, { sufix: "checkbox" })}>
        <input
          type="checkbox"
          className="el-form-checkbox__input"
          onChange={this.handleChange}
          onBlur={this.handleBlur}
          ref={refInput}
          checked={this.state.checked}
          {...testAttr(this.props, { sufix: "checkbox__input" })}
          {...rest}
        />
        <span className={checkboxShapeClasses} {...testAttr(this.props, { sufix: "checkbox__text" })} />
        {label}
      </label>
    );
  }
}
